// external libs
import { ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'
import axios from 'axios'
import Api from '../Services/SuriApi'

// redux
import GeneralActions, { GeneralTypes } from '../Redux/GeneralRedux'
import SettingsActions from '../Redux/SettingsRedux'
import UserDataActions from '../Redux/UserDataRedux'

const GetOperatingHoursEpic = (action$) =>
  action$.pipe(
    ofType(GeneralTypes.GET_SETTINGS_REQUEST),
    switchMap(() =>
      from(axios.all([Api.getSettings(), Api.getWorkingHours()])).pipe(
        switchMap(([responseSettings, responseWorkingHours]) =>
          from([
            GeneralActions.getSettingsRequestSuccess(),
            SettingsActions.setWebSettings(responseSettings.data.data),
            UserDataActions.setOperatingHoursFromContent(responseWorkingHours.data.data),
          ]),
        ),
        catchError(() => of(GeneralActions.onStopFetching())),
      ),
    ),
  )

export default GetOperatingHoursEpic
